import { MentionableModel } from '@renderer/chat'
import ModelIpcRouter, { ModelIpcRouterType } from '@shared/ipc/routers/ModelIpc.router'

class ModelIpcRenderer extends ModelIpcRouter implements ModelIpcRouterType {
  async fetchModels(forceRefresh?: boolean): Promise<MentionableModel[]> {
    return this.exec('fetchModels', forceRefresh)
  }

  async removeModel(modelId: string): Promise<boolean> {
    return this.exec('removeModel', modelId)
  }

  async setDefaultModel(modelId: string): Promise<void> {
    return this.exec('setDefaultModel', modelId)
  }
}

export default new ModelIpcRenderer()
